module.exports = __webpack_public_path__ + "img/位图(15).5b2ab8b1.png";